import { c as _c } from "react/compiler-runtime";
import { cn } from '@/app/_lib/utils';
type TypeScriptProps = React.SVGProps<SVGSVGElement> & {
  size?: string | number;
};
export function TypeScript(t0) {
  const $ = _c(12);
  let className;
  let props;
  let size;
  if ($[0] !== t0) {
    ({
      size,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = size;
  } else {
    className = $[1];
    props = $[2];
    size = $[3];
  }
  const sizeClass = size ? `size-${size}` : "size-12";
  let t1;
  if ($[4] !== className || $[5] !== sizeClass) {
    t1 = cn(sizeClass, className);
    $[4] = className;
    $[5] = sizeClass;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  let t3;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path fill="#fff" d="M22.67 47h99.67v73.67H22.67z" />;
    t3 = <path data-name="original" fill="#007acc" d="M1.5 63.91v62.5h125v-125H1.5zm100.73-5a15.56 15.56 0 017.82 4.5 20.58 20.58 0 013 4c0 .16-5.4 3.81-8.69 5.85-.12.08-.6-.44-1.13-1.23a7.09 7.09 0 00-5.87-3.53c-3.79-.26-6.23 1.73-6.21 5a4.58 4.58 0 00.54 2.34c.83 1.73 2.38 2.76 7.24 4.86 8.95 3.85 12.78 6.39 15.16 10 2.66 4 3.25 10.46 1.45 15.24-2 5.2-6.9 8.73-13.83 9.9a38.32 38.32 0 01-9.52-.1 23 23 0 01-12.72-6.63c-1.15-1.27-3.39-4.58-3.25-4.82a9.34 9.34 0 011.15-.73L82 101l3.59-2.08.75 1.11a16.78 16.78 0 004.74 4.54c4 2.1 9.46 1.81 12.16-.62a5.43 5.43 0 00.69-6.92c-1-1.39-3-2.56-8.59-5-6.45-2.78-9.23-4.5-11.77-7.24a16.48 16.48 0 01-3.43-6.25 25 25 0 01-.22-8c1.33-6.23 6-10.58 12.82-11.87a31.66 31.66 0 019.49.26zm-29.34 5.24v5.12H56.66v46.23H45.15V69.26H28.88v-5a49.19 49.19 0 01.12-5.17C29.08 59 39 59 51 59h21.83z" />;
    $[7] = t2;
    $[8] = t3;
  } else {
    t2 = $[7];
    t3 = $[8];
  }
  let t4;
  if ($[9] !== props || $[10] !== t1) {
    t4 = <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128 128" className={t1} {...props}>{t2}{t3}</svg>;
    $[9] = props;
    $[10] = t1;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
}